/**
 * VERI – Produktformulare (Produktkarte, später Produktseite / Shop-Liste)
 *
 * Markup-Vertrag (siehe snippets/veri-product-card.liquid, snippets/veri-quantity.liquid):
 *   <form data-veri-product-form data-label-adding="…" data-label-added="…">
 *     <input type="hidden" name="id" value="VARIANT_ID">
 *     <div data-veri-qty> <button data-veri-qty-minus> <input name="quantity"> <button data-veri-qty-plus> </div>
 *     <button type="submit" name="add" data-veri-add>In den Warenkorb</button>
 *     <button type="submit" name="return_to" value="/checkout" data-veri-buy-now>Sofort Kaufen</button>
 *     <p data-veri-form-error hidden></p>
 *   </form>
 *
 * - „In den Warenkorb“: AJAX (/cart/add.js), Button-Text → „Wird hinzugefügt …“ → „Hinzugefügt!“ (wie live),
 *   danach Header-Zähler [data-veri-cart-count] aktualisieren und Event `veri:cart:updated` auslösen.
 * - „Sofort Kaufen“: normales Formular-Submit mit return_to=/checkout (Shopify legt in den Warenkorb und leitet weiter).
 * - Ohne JS funktionieren beide Buttons trotzdem (Fallback: /cart bzw. /checkout).
 * - Mini-Feedback (16.10.2026): nach dem Hinzufügen Statuszeile unter dem Formular
 *   („Im Warenkorb: X € · Noch Y € bis zum kostenlosen Versand“ + Link zum Warenkorb). Den Versandtext liefert die
 *   Warenkorb-Section selbst ([data-veri-shipping-status], Section Rendering API /cart?sections=main) –
 *   Versandkosten/Schwelle werden also nur dort gepflegt.
 */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function updateQtyState(wrapper) {
    var input = wrapper.querySelector('input[name="quantity"]');
    var minus = wrapper.querySelector('[data-veri-qty-minus]');
    if (!input || !minus) return;
    var min = parseInt(input.min || '1', 10);
    minus.disabled = parseInt(input.value || '1', 10) <= min;
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-veri-qty-minus], [data-veri-qty-plus]');
    if (!btn) return;
    var wrapper = btn.closest('[data-veri-qty]');
    var input = wrapper && wrapper.querySelector('input[name="quantity"]');
    if (!input) return;
    var min = parseInt(input.min || '1', 10);
    var max = parseInt(input.max || '9999', 10);
    var value = parseInt(input.value || '1', 10) || min;
    value += btn.hasAttribute('data-veri-qty-plus') ? 1 : -1;
    input.value = Math.min(max, Math.max(min, value));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    updateQtyState(wrapper);
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-veri-qty] input[name="quantity"]')) {
      updateQtyState(event.target.closest('[data-veri-qty]'));
    }
  });

  function setCartCount(count) {
    document.querySelectorAll('[data-veri-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? String(count) : '';
      el.hidden = !(count > 0);
    });
    document.querySelectorAll('[data-veri-cart-label]').forEach(function (el) {
      var tpl = el.getAttribute('data-veri-cart-label');
      if (tpl) el.setAttribute('aria-label', tpl.replace('{{ count }}', count));
    });
  }

  function refreshCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCartCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('veri:cart:updated', { detail: { cart: cart } }));
        return cart;
      });
  }

  var CART_SECTION = 'main'; // Section-ID in templates/cart.json

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function showStatus(form, cart) {
    var el = form.querySelector('[data-veri-form-status]');
    if (!el) {
      el = document.createElement('p');
      el.className = 'veri-form-status';
      el.setAttribute('data-veri-form-status', '');
      el.setAttribute('role', 'status');
      form.appendChild(el);
    }
    var cartUrl = root + 'cart';
    var base = form.getAttribute('data-label-in-cart') || 'Im Warenkorb: {{ amount }}';
    var html = '<span>' + base.replace('{{ amount }}', formatMoney(cart.total_price, cart.currency)) + '</span>';
    el.innerHTML = html + ' <a href="' + cartUrl + '">' + (form.getAttribute('data-label-view-cart') || 'Zum Warenkorb') + '</a>';
    el.hidden = false;
    return fetch(root + 'cart?sections=' + CART_SECTION, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (json) {
        var markup = json && json[CART_SECTION];
        if (!markup) return;
        var doc = new DOMParser().parseFromString(markup, 'text/html');
        var text = doc.querySelector('[data-veri-shipping-status] .veri-cart__free-shipping-text');
        if (!text) return;
        var span = document.createElement('span');
        span.className = 'veri-form-status__shipping';
        span.innerHTML = text.innerHTML;
        el.insertBefore(span, el.querySelector('a'));
      })
      .catch(function () {});
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('[data-veri-product-form]')) return;
    var submitter = event.submitter;
    // „Sofort Kaufen“ → normales Submit mit return_to=/checkout
    if (submitter && submitter.hasAttribute('data-veri-buy-now')) return;

    event.preventDefault();
    var addBtn = form.querySelector('[data-veri-add]');
    if (!addBtn || addBtn.disabled) return;
    var errorEl = form.querySelector('[data-veri-form-error]');
    var originalLabel = addBtn.textContent;
    var labelAdding = form.getAttribute('data-label-adding') || originalLabel;
    var labelAdded = form.getAttribute('data-label-added') || originalLabel;

    var data = new FormData(form);
    data.delete('return_to');
    addBtn.disabled = true;
    addBtn.setAttribute('aria-busy', 'true');
    addBtn.textContent = labelAdding;
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (r) {
        return r.json().then(function (json) {
          if (!r.ok) throw json;
          return json;
        });
      })
      .then(function () {
        addBtn.textContent = labelAdded;
        return refreshCart().then(function (cart) { return showStatus(form, cart); });
      })
      .catch(function (err) {
        addBtn.textContent = originalLabel;
        if (errorEl) {
          errorEl.textContent = (err && (err.description || err.message)) || '';
          errorEl.hidden = !errorEl.textContent;
        }
      })
      .finally(function () {
        addBtn.removeAttribute('aria-busy');
        setTimeout(function () {
          addBtn.textContent = originalLabel;
          addBtn.disabled = false;
        }, 2000);
      });
  });

  window.VeriCart = { refresh: refreshCart, setCount: setCartCount };
})();
